import { v4 as uuidv4 } from 'uuid';
import { TEMPLATE_CATEGORIES } from './templateCategories';

// Extracted from legacy src/components/templates.js

export const TEMPLATES = [
  {
  id: 'coastalDreams',
  name: 'Градски мечти',
  category: TEMPLATE_CATEGORIES.CLASSIC,
  description: 'Елегантна градска сватба с модерни акценти — шаблон за сватбен уебсайт с таймлайн на любовта, галерия снимки и броене до деня. Перфектен за градско тържество в България.',
  previewImage: 'https://love.saschareinking.com/wp-content/uploads/2020/03/23-4649-post/top-wedding-locations-in-new-york-city_0273.jpg',
  theme: 'coastalDreams',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'fullscreen',
        imagePosition: 'background',
        title: 'Изабела и Лукас',
        subtitle: '15 август 2025 • Хотел "Градски дворец"',
        image: 'https://caratsandcake.com/_images/cache/CassiClaire_Isaacs_0536-209196-1658762855.jpg'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-08-15T16:00:00',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Сред градския блясък и модерните светлини, ще обединим сърцата си завинаги. Присъединете се към нас за магическо градско тържество.',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Градски ритми на любовта',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'timeline',
      props: {
        events: [
          {
            date: 'Лято 2023',
            title: 'Среща в града',
            description: 'Случайна среща в модерно кафене в центъра на града започна нашата урбанистична любовна история.',
            image: 'https://d39l2hkdp2esp1.cloudfront.net/img/photo/122622/122622_00_2x.jpg?20170601230600'
          },
          {
            date: 'Зима 2023',
            title: 'Градски приключения',
            description: 'От разходки по осветените булеварди до уютни вечери в ресторанти на покрива, всеки момент ни приближаваше към вечността.',
            image: 'https://images.stockcake.com/public/4/3/7/437f1516-65eb-4185-93e6-7756928efab5_large/evening-city-stroll-stockcake.jpg'
          },
          {
            date: 'Пролет 2024',
            title: 'Обещание под звездите',
            description: 'На терасата с гледка към града, с блясъка на светлините като свидетели, пръстенът бе предложен и бъдещето ни запечатано.',
            image: 'https://images.squarespace-cdn.com/content/v1/58308be803596e27e2393299/21f2787f-c674-4801-ba31-0521366580ab/new-york-city-elopement-packages-all-inclusive-promise-mountain-4.png'
          }
        ],
        style: 'urban',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Градски спомени',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'masonry',
        columns: 3,
        images: [
          'https://images.squarespace-cdn.com/content/v1/58308be803596e27e2393299/f8a04345-2d4c-4fe8-9fd5-5c21226791b5/new-york-city-elopement-packages-all-inclusive-promise-mountain-7.png',
          'https://images.squarespace-cdn.com/content/v1/5ff5284260aa3e48699810d1/f3866eff-3fa7-4f3e-b081-abc8d801294c/548.jpg?format=1500w',
          'https://images.stockcake.com/public/b/8/1/b81fea0f-f9f3-427f-a9bd-3108464c78eb_large/elegant-dinner-date-stockcake.jpg',
        ],
        spacing: 'medium',
        captions: true
      }
    }
  ]
},
 {
  id: 'tropical-paradise',
  name: 'Тропически Рай',
  category: TEMPLATE_CATEGORIES.VIBRANT,
  description: 'Живописен тропически шаблон за сватбен уебсайт с тюркоазени цветове и екзотична атмосфера. Включва галерия, броене, RSVP и таймлайн за вашата сватба.',
  previewImage: 'https://chlomoprojects.com/wp-content/uploads/2023/11/DSC_8608-scaled.jpg',
  theme: 'tropicalParadise',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'fullscreen',
        imagePosition: 'background',
        title: 'Мая и Итън',
        subtitle: '22 юни 2025 • Курорт Палм Коув',
        image: 'https://blog.destinationweddings.com/wp-content/uploads/2019/02/SERPC_Wedding-Gazebo_3A.jpg'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-06-22T17:00:00',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Заобиколени от пищния тропически рай, който плени сърцата ни, ви каним да споделите нашето празненство на любовта под палмите и звездното небе.',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Открити Рай',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'timeline',
      props: {
        events: [
          {
            date: 'Пролет 2023',
            title: 'Островно Приключение',
            description: 'Ваканция, която промени всичко, когато се срещнахме докато изследвахме скрити водопади на тропически остров.',
            image: 'https://images.pexels.com/photos/450441/pexels-photo-450441.jpeg'
          },
          {
            date: 'Есен 2023',
            title: 'Екзотични Пътешествия',
            description: 'От джунглата до коралови рифове - всяко приключение ни приближаваше към нашия вечен рай заедно.',
            image: 'https://images.saymedia-content.com/.image/ar_4:3%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:eco%2Cw_1200/MTg5ODIzMTE0ODAzNzUwMTE0/jungles-of-the-world.jpg'
          },
          {
            date: 'Зима 2024',
            title: 'Предложение в Рая',
            description: 'При залез слънце на нашия любим уединен плаж, заобиколени от факли и тропически цветя, започна нашето бъдеще.',
            image: 'https://marine-project.com/wp-content/plugins/phastpress/phast.php/c2VydmljZT1pbWFnZXMmc/3JjPWh0dHBzJTNBJTJGJTJGbWFyaW5lLXByb2plY3QuY29tJTJGd3AtY29udGVudCUyRnVwbG9hZHMlMkYyMDI0JTJGMDklMkZCb25maXJlLUJsaXNzLUJyaXRpc2gtdmlyZ2luLWlzbGFuZC1sdXh1cnkteWFjaHQtY2hhcnRlci5qcGcmY2FjaGVNYXJrZXI9MTcyNzE2MTkzNC05NDQwMzYmdG9rZW49MjdlZjJjNGEzYWVkYmM4Mg.q.jpg'
          }
        ],
        style: 'coastal',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Тропически Спомени',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'masonry',
        columns: 3,
        images: [
          'https://www.visittci.com/core/cover-bonfire-beach-long-bay-providenciales_1024x341.jpg',
          'https://muralsyourway.vtexassets.com/arquivos/ids/238359/Tropical-Paradise-Wall-Mural.jpg?v=638164834895700000',
          'https://www.wallpapergap.com/cdn/24/257/tropical-paradise-wallpaper-1440x900.jpg',
        ],
        spacing: 'medium',
        captions: true
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Елате да споделим магията на тропическия рай, където любовта цъфти като хибискус под топлото слънце.',
        alignment: 'center',
        size: 'medium'
      }
    }
  ]
},
  {
    id: 'sunset-beach',
    name: 'Залез на плажа',
    category: TEMPLATE_CATEGORIES.CLASSIC,
    description: 'Романтична сватба на плажа — шаблон за сватбен уебсайт с пурпурни и кехлибарени нюанси. Идеален за морска сватба в България с галерия, броене и таймлайн.',
    previewImage: 'https://images.stockcake.com/public/e/5/6/e5623ae2-adc2-413d-b349-ed1eb69a8742_large/sunset-beach-wedding-stockcake.jpg',
    theme: 'sunsetBeach',
    sections: [
      {
        id: uuidv4(),
        type: 'hero',
        props: {
          height: 'fullscreen',
          imagePosition: 'background',
          title: 'Петър & Мария',
          subtitle: '30 Юли, 2025 • Златни Пясъци',
          image: 'https://images.squarespace-cdn.com/content/v1/561bc345e4b02c7f02762de3/86ca4101-96fb-4771-92b8-e192eed71ebb/susnet+beach+weddings+1.jpg'
        }
      },
      {
        id: uuidv4(),
        type: 'countdown',
        props: {
          weddingDate: '2025-07-30T18:30:00',
          alignment: 'center'
        }
      },
      {
        id: uuidv4(),
        type: 'text',
        props: {
          content: 'Докато слънцето залязва над хоризонта, оцветявайки небето в ярки цветове, ви каним да станете свидетели на нашата отдаденост един на друг в чест на любовта и новите начала.',
          alignment: 'center',
          size: 'large'
        }
      },
      {
        id: uuidv4(),
        type: 'timeline',
        props: {
          events: [
            {
              date: 'Лято 2023',
              title: 'Среща в здрач',
              description: 'Пътищата ни се пресякоха на парти край огъня на плажа, където разговорите продължиха до зори и се зароди началото на нещо красиво.',
              image: 'https://images.squarespace-cdn.com/content/v1/5baa7244a568277ab8669d8f/1677700343361-6N503USLWQ6OF1AIGB0H/backroad+bonfire+engagement+photos+tennessee+wedding+photographer+poppy+and+vine+%281%29.jpg'
            },
            {
              date: 'Есен 2024',
              title: 'Разходки по залез слънце',
              description: 'Вечерните разходки по брега се превърнаха в наш ритуал, където споделяхме мечти и връзката ни ставаше все по-силна с всеки изминал залез.',
              image: 'https://images.stockcake.com/public/f/6/3/f637f2f1-d4a5-4105-acce-6aaaf6dba4ef_large/sunset-beach-walk-stockcake.jpg'
            },
            {
              date: 'Лято 2025',
              title: 'Златен час',
              description: 'В най-вълшебния момент на деня, когато слънцето докосна морето, беше зададен въпрос, който промени живота ни завинаги.',
              image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Sunset_at_Long_Beach_%28South_Africa%29.jpg/500px-Sunset_at_Long_Beach_%28South_Africa%29.jpg'
            }
          ],
          style: 'elegant',
          alignment: 'center'
        }
      },
      {
        id: uuidv4(),
        type: 'text',
        props: {
          content: 'Златни Спомени',
          alignment: 'center',
          size: 'large'
        }
      },
      {
        id: uuidv4(),
        type: 'gallery',
        props: {
          layout: 'masonry',
          columns: 3,
          images: [
            'https://i.pinimg.com/736x/fb/ab/90/fbab90461eeb71c828fcc5d278c2a5cc.jpg',
            'https://cdn0.weddingwire.com/vendor/988036/3_2/960/jpg/1515530675-a39dd5d46d261ad1-1510183635686-4d19069c-307f-45ba-87a4-b7cfcd3f5ff4-rs2001.480..jpeg',
            'https://mephotography.com.au/wp-content/uploads/2024/04/2024-04-15_0006.jpg',
          ],
          spacing: 'medium',
          captions: true
        }
      }
    ]
  },
  {
    id: 'simple-card',
    name: 'Покана',
    category: TEMPLATE_CATEGORIES.MINIMAL,
    description: 'Изчистен и елегантен шаблон за сватбен уебсайт тип покана. Минималистичен дизайн с текст и снимка — идеален за кратка електронна покана за сватба.',
    previewImage: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?auto=format&fit=crop&w=1200&q=80',
    theme: 'simpleElegance',
    sections: [
      {
        id: uuidv4(),
        type: 'hero',
        props: {
          height: 'medium',
          imagePosition: 'background',
          title: 'Мартин & Елизабет',
          subtitle: '22 юни 2025 • Златни Пясъци',
          image: 'https://x.dkphoto.ie/wp-content/uploads/2024/03/Brides-Guide-to-Selecting-the-Perfect-Wedding-Dress.jpg.webp'
        }
      },
      {
        id: uuidv4(),
        type: 'text',
        props: {
          content: 'Имаме удоволствието да Ви поканим да споделите радостта ни в празнуването на сватбения ни ден. Присъединете се към нас за церемония, последвана от прием, изпълнен с любов, смях и скъпи моменти.',
          alignment: 'center',
          size: 'large'
        }
      }
    ]
  },
  {
  id: 'modernMinimal',
  name: 'Модерен Минимализъм',
  category: TEMPLATE_CATEGORIES.MINIMAL,
  description: 'Съвременен минималистичен шаблон за сватбен уебсайт с изчистени линии, фини детайли, броене до деня и секция за историята на двойката.',
  previewImage: 'https://i.pinimg.com/736x/23/17/07/231707e88b7cf287b881ed1e17c9ed26.jpg',
  theme: 'modernMinimal',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'large',
        imagePosition: 'background',
        title: 'Ема и Джеймс',
        subtitle: '22 юни 2025 • Златни Пясъци',
        image: 'https://www.theknot.com/tk-media/images/c0844625-d9b0-4959-af26-8d473bba0350'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Нашата История',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Сред безбройните възможности на живота, ние се намерихме един друг. Нашето пътешествие е изпълнено с моменти на радост, израстване и непоколебима подкрепа. Днес ви каним да станете свидетели на новата глава от нашата история, докато започваме общия си живот.',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-09-20T16:00:00',
        alignment: 'center'
      }
    }
  ]
},
  {
    id: 'romantic-vintage',
    name: 'Романтична Носталгия',
    category: TEMPLATE_CATEGORIES.CLASSIC,
    description: 'Вечен и елегантен шаблон за сватбен уебсайт с ретро типография, романтични детайли, таймлайн на любовта, галерия и броене до сватбата.',
    previewImage: 'https://images.unsplash.com/photo-1523438885200-e635ba2c371e?auto=format&fit=crop&w=1200&q=80',
    theme: 'romanticVintage',
    sections: [
      {
        id: uuidv4(),
        type: 'hero',
        props: {
          height: 'fullscreen',
          imagePosition: 'background',
          title: 'Изабела & Александър',
          subtitle: '22 юни 2025 • Златни Пясъци',
          image: 'https://cavanaghphotography.com.au/wp-content/uploads/2020/04/ben-ean-wedding54.jpg?x29516'
        }
      },
      {
        id: uuidv4(),
        type: 'text',
        props: {
          content: 'Нашата любовна история',
          alignment: 'center',
          size: 'large'
        }
      },
      {
        id: uuidv4(),
        type: 'timeline',
        props: {
          events: [
            {
              date: 'Лято 2023',
              title: 'Първа Среща',
              description: 'Случайна среща на градинско парти, която промени живота ни завинаги.',
              image: 'https://www.savvymom.ca/wp-content/uploads/2020/05/recipegeek-entertain-how_to_throw_a_killer_retro_garden_party.jpg'
            },
            {
              date: 'Зима 2024',
              title: 'Предложението',
              description: 'Под звездите, с пръстен, който обещаваше вечност.',
              image: 'https://images.stockcake.com/public/8/a/8/8a8a155c-5ee2-420b-ace5-13855ecb718c_large/starry-romantic-night-stockcake.jpg'
            }
          ],
          style: 'elegant',
          alignment: 'center'
        }
      },
       {
        id: uuidv4(),
        type: 'countdown',
        props: {
          weddingDate: '2025-07-30T18:30:00',
          alignment: 'center'
        }
      },
      {
        id: uuidv4(),
        type: 'gallery',
        props: {
          layout: 'grid',
          columns: 2,
          images: [
            'https://hips.hearstapps.com/hmg-prod/images/img-9868-1603303155.jpg',
            'https://symphonyevents.com.au/wp-content/uploads/2021/08/cover.jpg'
          ],
          spacing: 'medium',
          captions: true
        }
      }
    ]
  },
 {
  id: 'bold-contemporary',
  name: 'Смел съвременен стил',
  category: TEMPLATE_CATEGORIES.MODERN,
  description: 'Модерен и смел шаблон за сватбен уебсайт с едра типография, драматични контрасти, галерия снимки и броене до големия ден.',
  previewImage: 'https://images.squarespace-cdn.com/content/v1/5af88aebaf2096fff4db85ff/1591169787154-FWGRZVHRA9QLCUY4NEE8/1.jpg',
  theme: 'boldContemporary',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'fullscreen',
        imagePosition: 'background',
        title: 'СОФИЯ И ЛУКАС',
        subtitle: '22 юни 2025 • Курорт Палм Коув',
        image: 'https://images.squarespace-cdn.com/content/v1/59fcda56f43b55658f7a101c/1594674114860-SO4JVI155Q8POFVFWJ0U/FL-1840.jpg'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'ЗАЕДНО',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Празнуваме нашата любов в церемония, която отразява нашия смел и модерен дух. Вашето присъствие би направило нашия ден незабравим и пълен с радост.',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-10-10T17:00:00',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'МОМЕНТИ НА ЛЮБОВ',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'masonry',
        columns: 3,
        images: [
          'https://www.brides.com/thmb/IpssVfgOJgOzUNjPClfYOHXNkW0=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/madison-jonathan_26-69477de1d8d54825a4ed920879ed4c41.jpg',
          'https://junebugweddings.com/wedding-blog/wp-content/uploads/2022/08/elegantly-modern-basilica-hudson-wedding-nicole-nero-20.jpg',
          'https://weddingconcepts.co.za/wp-content/uploads/2017/10/aaronfabrizio_wedding_32.jpg'
        ],
        spacing: 'large',
        captions: false
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'С нетърпение очакваме да споделим този специален ден с вас - нашите най-близки хора.',
        alignment: 'center',
        size: 'medium'
      }
    }
  ]
},
  {
  id: 'playful-modern',
  name: 'Игрив модерен стил',
  category: TEMPLATE_CATEGORIES.MODERN,
  description: 'Забавен и съвременен шаблон за сватбен уебсайт със закръглени ъгли, игриви елементи, галерия и броене до сватбения ден.',
  previewImage: 'https://assets.easyweddings.com/files/2021/10/30163043/modern-wedding-etiquette.jpg',
  theme: 'playfulModern',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'large',
        imagePosition: 'background',
        title: 'Мия и Ноа',
        subtitle: '22 юни 2025 • Златни Пясъци',
        image: 'https://maggieblogassets.sfo2.digitaloceanspaces.com/wp-content/uploads/2014/11/Modern-Lakeside_Blog-Header.png'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Женим се!',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Присъединете се към нас за ден, изпълнен с любов, смях и празнуване, докато започваме нашето общо пътуване.',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-07-25T15:00:00',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Моменти на щастие',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'grid',
        columns: 2,
        images: [
          'https://ik.imagekit.io/ivorytribe/wp-content/uploads/2023/08/09221648/IT_RW-CHELSEA-DYLAN-wallflowerweddings-49.jpg',
          'https://burghbrides-wp.s3.amazonaws.com/uploads/2020/12/Burgh_Brides_Pittsburgh_Wedding_Elegant_Pennsylvanian_Wedding_Playful_Spins_6334-1024x683.jpg',
          'https://i.pinimg.com/originals/4b/28/25/4b2825855d5042875a67af3e89f15b4e.png',
          'https://static1.squarespace.com/static/645d44f04d75bf75868222f6/t/66fb0d74342c4807201ccce9/1727729012484/winter-wedding-dress-share2.jpg?format=1500w'
        ],
        spacing: 'medium',
        captions: true
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Oчакваме да споделим този специален ден с вас',
        alignment: 'center',
        size: 'medium'
      }
    }
  ]
},
 {
  id: 'vibrant-celebration',
  name: 'Ярко Празненство',
  category: TEMPLATE_CATEGORIES.VIBRANT,
  description: 'Динамичен и цветен шаблон за сватбен уебсайт с таймлайн, галерия, броене и множество секции за пълно представяне на вашата сватба.',
  previewImage: 'https://atlantastyleweddings.com/wp-content/uploads/2024/01/AJ_189-1024x684.jpg',
  theme: 'vibrantCelebration',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'fullscreen',
        imagePosition: 'background',
        title: 'Ема и Джеймс',
        subtitle: '22 юни 2025 • Курорт Палм Коув',
        image: 'https://partyslate.imgix.net/photos/1946200/photo-c0453bc1-8621-4942-8a38-78ff25ec54ab.jpg?ixlib=js-2.3.2&auto=compress%2Cformat&bg=fff&cs=srgb'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Нашата История Започва',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'timeline',
      props: {
        events: [
          {
            date: 'Първата Среща',
            title: 'Случайна Среща в Кафенето',
            description: 'Една случайна среща при чаша лате, която запали незабравима връзка.',
            image: 'https://st4.depositphotos.com/9378882/27456/i/450/depositphotos_274561434-stock-photo-happy-couple-man-woman-sitting.jpg'
          },
          {
            date: 'Първо Срещане',
            title: 'Разходка по Залез',
            description: 'Разхождахме се по плажа, докато слънцето рисуваше небето в блестящи цветове.',
            image: 'https://images.unsplash.com/photo-1622402263489-c5623321f813?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
          },
          {
            date: 'Предложението',
            title: 'Под Звездите',
            description: 'Магическа вечер, която завинаги промени живота ни.',
            image: 'https://www.shutterstock.com/image-photo/couple-walking-alley-night-lights-600nw-1692560254.jpg'
          }
        ],
        style: 'modern',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Елате на Нашето Празненство',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Каним ви да бъдете част от нашия специален ден, в който ще празнуваме любовта си и ще започнем тази нова глава от живота си заедно. Вашето присъствие ще направи празненството ни пълно.',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-09-15T16:00:00',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'masonry',
        columns: 3,
        images: [
          'https://media.istockphoto.com/id/1126844538/photo/happy-young-couple.jpg?s=612x612&w=0&k=20&c=Apu9fu8mw_KxTrcdHi-bP4aHDOfn9oKAf-YTHPmfTIY=',
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7ejPK0XRx_jVauCqUrsxa3IJC9axPhJZzvA&s',
          'https://junebugweddings.com/wedding-blog/wp-content/uploads/2022/10/Maggie-Grace-Photography-30.jpg',
          'https://images.unsplash.com/photo-1588632258523-26242d0a8c2c?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y291cGxlJTIwd2Fsa2luZyUyMG9uJTIwdGhlJTIwYmVhY2h8ZW58MHx8MHx8fDA%3D',
          'https://images-pw.pixieset.com/page/vw9AVL/JacobAmandaPreview-ForbisFotography-36-c3c50d09-1500.jpg',
          'https://marrymetampabay.com/wp-content/uploads/2025/03/16Vibrant-Jewel-Toned-Tampa-Wedding-Inspiration-Florida-Aquarium-jpg.webp'
        ],
        spacing: 'large',
        captions: true
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Подробности',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Церемония: 16:00 ч.\nПрием: 18:00 ч.\nМясто: Гранд Гардън\nДрескод: Елегантно-неформално',
        alignment: 'center',
        size: 'medium'
      }
    }
  ]
},
{
  id: 'garden-bliss',
  name: 'Градинска Идилия',
  category: TEMPLATE_CATEGORIES.MODERN,
  description: 'Свеж природен шаблон за сватбен уебсайт, вдъхновен от градинска красота и пролетни цветове. Включва галерия, броене и подробности за събитието.',
  previewImage: 'https://imagesawe.s3.amazonaws.com/styles/max980/s3/albums/2021/02/05/garden_wedding_in_qatar-18.jpg?itok=Es7mDMzY',
  theme : 'garden-bliss',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'fullscreen',
        imagePosition: 'background',
        title: 'Мартин и Катрин',
        subtitle: '22 юни 2025 • Златни Пясъци',
        image: 'https://hannahmia.com/wp-content/uploads/2019/12/how-to-plan-a-back-garden-wedding-013.jpg'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Нашата Градинска Приказка',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'В сърцето на природата ще започнем най-красивата глава от нашия живот. Заобиколени от зеленина и цветя, ще кажем своите клетви и ще се заклянем в вечна любов.',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-09-15T16:00:00',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'masonry',
        columns: 3,
        images: [
          'https://smp-is.stylemepretty.com/submissions/uploads/372345/67589dc5a99f5$!1125x.jpg',
          'https://www.marthastewart.com/thmb/fbZ53JJclPr31KTRMyVO-WWf3yk=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/julie-chris-wedding-ceremony-0844-s12649-0216_vert-2000-28594aecb277445a8b84b8e6b064cf55.jpg',
          'https://fairchildgarden.org/wp-content/uploads/2024/09/JullieDavid-1-scaled.jpg'
        ],
        spacing: 'large',
        captions: true
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Подробности за Празненството',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Церемония: 16:00 ч.\nПрием: 18:00 ч.\nМясто: Ботаническа Градина\nДрескод: Градинско елегантно\n\nОчакваме ви за незабравим ден сред природата!',
        alignment: 'center',
        size: 'medium'
      }
    }
  ]
},
 {
  id: 'cleanLines',
  name: 'Изчистени Линии',
  category: TEMPLATE_CATEGORIES.MINIMAL,
  description: 'Ултра-минималистичен шаблон за сватбен уебсайт с перфектна типография, галерия снимки и елегантен изчистен дизайн.',
  previewImage: 'https://www.lovemydress.net/wp-content/uploads/2019/01/Clare-Randell-Photography-Rochelle-Tony-clarerandellphotography@gmail.com-57-1.jpg',
 theme : 'cleanLines',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'fullscreen',
        imagePosition: 'background',
        title: 'Мая и Мартин',
        subtitle: '22 юни 2025 • Курорт Палм Коув',
        image: 'https://combermereabbey.co.uk/static/uploads/sites/4/2024/07/bride-and-groom-at-combermere_liamandbee.webp'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Нашата История',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'В един свят, изпълнен със сложности, ние открихме красотата в простотата. Нашата любов е като изчистена линия - елегантна, съвършена и вечна. Заедно създаваме история, написана с нежност и искреност.',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'grid',
        columns: 2,
        images: [
          'https://images.vivaweddingphotography.com/wp-content/uploads/2022/08/17074031/rustic-wedding-decorations-17.jpeg',
          'https://www.thegildedgown.com/wp-content/uploads/2023/11/CSP_2530-683x1024.jpg',
        ],
        spacing: 'small',
        captions: true
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'С благодарност за всеки момент, споделен заедно',
        alignment: 'center',
        size: 'small'
      }
    }
  ]
},
  {
  id: 'festiveJoy',
  name: 'Празнична Радост',
  category: TEMPLATE_CATEGORIES.VIBRANT,
  description: 'Цветен и празничен шаблон за сватбен уебсайт с живи елементи, галерия, таймлайн, броене и секции за историята на двойката.',
  previewImage: 'https://cliveblair.co.uk/wp-content/uploads/2021/07/modern-wedding-005.jpg',
  theme: 'festiveJoy',
  sections: [
    {
      id: uuidv4(),
      type: 'hero',
      props: {
        height: 'fullscreen',
        imagePosition: 'background',
        title: 'Калоян и Марина',
        subtitle: '22 юни 2025 • Курорт Палм Коув',
        image: 'https://images.ctfassets.net/77l22z9el0aa/5fcM2bIpDB4iLSzEfF9goj/d796846d03f6c471f6d214941c8d2e1d/hero_macklerstudios.png',
        ctaText: 'Нашата История',
        ctaLink: '#story'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Нашата Приказна История',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'В един магичен ден нашите пътища се пресякоха и животът ни се изпълни с цветове, смях и безгранична радост. Всеки момент, прекаран заедно, е като празник - ярък, весел и незабравим. Днес ви каним да споделите най-щастливия ден от нашия живот!',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Галерия от Спомени',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'gallery',
      props: {
        layout: 'masonry',
        columns: 3,
        images: [
          'https://www.thecelebrantdirectory.com/assets/2025/04/Sonal-Dave-multicultural-festival-wedding-independent-celebrant-wedding.jpeg',
          'https://goss.ie/wp-content/uploads/2022/11/image-1.png',
          'https://d397bfy4gvgcdm.cloudfront.net/409349-1453792-1044.jpeg',
          'https://images.squarespace-cdn.com/content/v1/62b8562b8c39ad7d5c490f40/1697119688329-9RQDZM1KT0JXNJT80ZJ4/image-asset.jpeg',
          'https://higherholcombe.co.uk/wp-content/uploads/2022/02/devon-woodland-wedding-venue-west-fest-1080x675.jpg',
          'https://press.fourseasons.com/content/dam/fourseasons/images/web/HKG/HKG_4520_aspect16x9.jpg/jcr:content/renditions/cq5dam.web.press.722.keepaspectratio.jpeg'
        ],
        spacing: 'medium',
        captions: true
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Обратно Броене до Големия Ден',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'countdown',
      props: {
        weddingDate: '2025-06-22T16:00:00',
        alignment: 'center'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Празнувайте с Нас',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Нашата сватба ще бъде истинско празненство на любовта, радостта и приятелството. Ще има музика, танци, смях и много сладки изненади. Елате готови да празнуваме до зори!',
        alignment: 'center',
        size: 'medium'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'С Обич и Благодарност',
        alignment: 'center',
        size: 'large'
      }
    },
    {
      id: uuidv4(),
      type: 'text',
      props: {
        content: 'Благодарим ви, че сте част от нашия живот и че ще споделите този специален ден с нас. Вашата любов и подкрепа означават всичко за нас. Не можем да дочаваме да празнуваме заедно!',
        alignment: 'center',
        size: 'medium'
      }
    }
  ]
}
];
